import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=c4e8bfae&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4e8bfae')) {
      api.createRecord('c4e8bfae', component.options)
    } else {
      api.reload('c4e8bfae', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=c4e8bfae&", function () {
      api.rerender('c4e8bfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wo5Q3uq8zrpG/JS/comp/childrenage.vue"
export default component.exports